import { jsxs, jsx } from 'react/jsx-runtime';

const CarbonFree = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M32.0019 46.5346C40.032 46.5346 46.5417 40.0255 46.5417 31.9961C46.5417 23.9667 40.032 17.4576 32.0019 17.4576C23.9718 17.4576 17.4621 23.9667 17.4621 31.9961C17.4621 40.0255 23.9718 46.5346 32.0019 46.5346ZM32.0019 52.9961C43.601 52.9961 53.0039 43.5941 53.0039 31.9961C53.0039 20.3981 43.601 10.9961 32.0019 10.9961C20.4029 10.9961 11 20.3981 11 31.9961C11 43.5941 20.4029 52.9961 32.0019 52.9961Z",
            fill: "#38D200"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M32.0028 36.5238C33.5492 36.5239 34.8032 37.7778 34.8032 39.3243C34.8031 40.8707 33.5492 42.1246 32.0028 42.1247C30.4563 42.1247 29.2025 40.8707 29.2024 39.3243C29.2024 37.7777 30.4562 36.5238 32.0028 36.5238Z",
            fill: "#0F7AED"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M32.0011 22.1995C33.4449 22.1995 34.6159 23.3699 34.6161 24.8136V31.54C34.6161 32.9839 33.445 34.155 32.0011 34.155C30.5573 34.1548 29.3869 32.9838 29.3869 31.54V24.8136C29.3871 23.37 30.5574 22.1997 32.0011 22.1995Z",
            fill: "#0F7AED"
          }
        )
      ]
    }
  );
};

export { CarbonFree };
